import React, { useState, useEffect, useContext, useRef } from "react";

import { I_AdData } from "../../Models/interfaces";
import { getRandomAdService } from "../../Services/Ads/get/getRandomAdService";
import { UserTokenContext } from "../../Contexts/userToken";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PendingManager from "../../Components/PendingManager/PendingManager";
import { submitAdEndService } from "../../Services/Ads/post/SubmitAdEndService";

const Ads2 = () => {
  const [adData, setAdData] = useState<I_AdData>({
    count: 1,
    gift: 2001,
    id: 32172231,
    price: 2,
    title: "",
    video_url: "",
  });
  const userToken = useContext(UserTokenContext);
  const navigate = useNavigate();
  const [isPending, setIsPending] = useState<boolean>(true);
  const videoEl = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    getRandomAdService(userToken)
      .then(({ data: { data } }) => {
        console.log(data);
        if (
          data.video_url === null ||
          data.video_url === "null" ||
          data.video_url === undefined ||
          data.video_url === "undefined"
        ) {
          Swal.fire({
            icon: "error",
            title: "در حال حاضر تبلیغی موجود نیست",
          }).then(() => {
            navigate("/");
            setAdData({
              count: 1,
              gift: 2001,
              id: 32172231,
              price: 2,
              title: "",
              video_url: "",
            });
          });
          return;
        } else {
          setAdData({
            count: data.count,
            gift: data.gift,
            id: data.id,
            price: 2,
            title: data.title,
            video_url: data.video_url,
          });
          setIsPending(false);
        }
      })
      .catch((err) => {
        setIsPending(false);
        console.log(err);
        Swal.fire({
          icon: "error",
          title: err?.response?.data?.message
            ? err?.response?.data?.message
            : err.message,
        });
      });
  }, [userToken, navigate]);
  return (
    <>
      <video
        onEnded={() => {
          Swal.fire({
            icon: "success",
            title: ` مبلغ ${adData.gift} تومان به حساب شما اضافه میشود`,
          }).then(() => {
            navigate("/");
            submitAdEndService(userToken, adData.id)
              .then(() => {})
              .catch((err) => {
                console.log(err);
              });
          });
        }}
        src={adData.video_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
        autoPlay={true}
        playsInline={true}
        controls={false}
        ref={videoEl}
        onLoadedData={() => {
          if (!videoEl.current) return;

          videoEl.current.play();
        }}
        onClick={() => {
          if (!videoEl.current) return;

          videoEl.current.play();
        }}
      ></video>

      <div className="absolute w-full">
        <PendingManager data={<></>} isPending={isPending} />
      </div>
    </>
  );
};

export default Ads2;
